// Global re-auth gate.
// When both the access token and the refresh cookie are expired, apiRequest
// calls waitForReAuth() instead of immediately logging out.  A modal dialog
// captures the REAUTH_REQUIRED_EVENT, lets the user re-enter their password,
// then calls resolveReAuth() (success) or rejectReAuth() (cancel / give up).

import { clearToken } from './tokenStore';

export const REAUTH_REQUIRED_EVENT = 'arch-editor:reauth-required';

type Waiter = { resolve: () => void; reject: (e: Error) => void };

let waiters: Waiter[] = [];
let modalOpen = false;

/** Called by apiRequest when both token and refresh failed. */
export function waitForReAuth(): Promise<void> {
  return new Promise((resolve, reject) => {
    waiters.push({ resolve, reject });
    if (!modalOpen) {
      modalOpen = true;
      window.dispatchEvent(new Event(REAUTH_REQUIRED_EVENT));
    }
  });
}

/** Called by SessionExpiredModal after a successful re-login. */
export function resolveReAuth(): void {
  modalOpen = false;
  const queue = waiters;
  waiters = [];
  queue.forEach((w) => w.resolve());
}

/** Called by SessionExpiredModal when the user cancels / gives up. */
export function rejectReAuth(): void {
  modalOpen = false;
  const queue = waiters;
  waiters = [];
  // Fire logout — causes AuthContext to clear user → ProtectedRoute redirects.
  clearToken();
  queue.forEach((w) => w.reject(new Error('Сессия завершена')));
}
